exports.fetchUrl = url =>
  process.env.NODE_ENV === 'production'
    ? `https://api.hp.c1ms.com/${url}`
    : `http://localhost:4000/${url}`;
